module.exports = __webpack_public_path__ + "05fbb4b4463d6df60eb45c6408ad59e5.png";